import styled from "styled-components";
import { Select, Radio, Col, Row } from "antd";

import * as Layout from "common/layout";
import { SectionTitle } from "common/text";

const { PageSection } = Layout;

type BannerSectionProps = {
  "background-url": string;
};

export const BannerSection = styled(PageSection)`
  background-color: #1070b6;
  background-image: ${(props: BannerSectionProps) =>
    props["background-url"] ? `url(${props["background-url"]})` : ""};
  background-repeat: repeat;
`;

export const CourseBannerTitle = styled(SectionTitle)`
  color: white;
`;

export const CourseTypeFilter = styled(Radio.Group)`
  display: flex;
  flex-direction: row;
  border: none;

  & .ant-radio-button-wrapper {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #707070;
    padding: 0px 12px;
    border: none;
  }

  & .ant-radio-button-wrapper:hover {
    color: #707070;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover::before {
    background-color: transparent;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    background-color: transparent;
  }
  .ant-radio-button-wrapper:not(:first-child)::before {
    width: 0px;
  }

  & .ant-radio-button-wrapper-checked {
    background-color: #d3e8ff;
    border: none;
  }

  & .ant-radio-button-wrapper-checked * {
    border: none;
  }
`;

export const LevelSelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const SelectorLabel = styled(Col)`
  display: flex;
  font-size: 16px;
  color: white;
  font-weight: bold;
  align-items: center;
  margin-right: 4px;
  text-align: left;
`;

export const LevelSelector = styled(Select)`
  height: 36px;
  font-size: 15px;
  color: black;
  width: 160px;
  flex-grow: 1;

  &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 100%;
    background-color: #ffffff;
    justify-content: center;
    text-align: left;
    display: flex;
    align-items: center;
    padding: 0px 16px;
  }

  &.ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector::placeholder {
    color: #707070;
  }

  & .ant-select-arrow {
    margin-right: 8px;
  }

  &.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
    justify-content: center;
    display: flex;
    align-items: center;
  }
`;

export const LanguageSelector = styled(LevelSelector)`
  width: 150px;
  flex-grow: 0;
`;

export const CourseSelector = styled(LevelSelector)`
  width: 100%;
  margin-bottom: 12px;
  & .ant-select-selection-placeholder {
    color: black;
    font-size: 18px;
    font-weight: bold;
    opacity: 0.8;
  }
  & .rc-virtual-list-scrollbar {
    display: ${(props) => (props.virtual ? "block" : "none")} !important;
    // use the unused virtual attribute from antd select since this list may not be long, and virtual or non-virtual scrolling will not affect speed that much.
  }
`;

export const TimeInfoRow = styled(Row)`
  margin-bottom: 8px;
`;

export const TimeInfo = styled.div`
  color: white;
  font-size: 11px;
  margin-left: 18px;
`;
